//@flow
import * as React from 'react';
import { Chip, Position, Tooltip, Text } from '@locus-taxy/neo-ui';

type TeamChipPropTypes = {
    color: string,
    teamLabel: string,
    maxWidth?: number,
    size?: 'small' | 'medium'
};

const TeamChip = (props: TeamChipPropTypes): React.Node => {
    const { color, teamLabel, size = 'medium', maxWidth = 80 } = props;
    return (
        <Tooltip shouldWrapChildren tooltip={teamLabel} delay={500}>
            <Position display="flex" position="relative">
                <Position
                    position="absolute"
                    width="4px"
                    height="100%"
                    backgroundColor={color}
                    borderTopLeftRadius="2px"
                    borderBottomLeftRadius="2px"
                />
                <Chip size={size}>
                    <Text
                        truncated
                        sx={{
                            maxWidth
                        }}
                        pl={1}
                    >
                        {teamLabel}
                    </Text>
                </Chip>
            </Position>
        </Tooltip>
    );
};

export default TeamChip;
